import { useEffect } from 'react';
import Text from './Text';
import Wrapper from '../assets/wrappers/NftContainer';
import { useSelector, useDispatch } from 'react-redux';
import Loading from './Loading';
import { getTextPaginate, setPage } from '../features/text/textSlice';
import PageButtonContainer from './PageButtonContainer';

const TextContainer = () => {
  const { paginate, isLoading } = useSelector((store) => store.text);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTextPaginate());
  }, [paginate.page, dispatch]);

  if (isLoading) {
    return <Loading />;
  }

  if (paginate.docs.length === 0) {
    return (
      <Wrapper>
        <h2>No draft to display...</h2>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <h5>
        {paginate.totalDocs} Draft{paginate.totalDocs > 1 && 's'} found
      </h5>
      <div className='jobs'>
        {paginate.docs.map((text) => {
          return <Text key={text._id} {...text} />;
        })}
      </div>
      {paginate.totalPages > 1 && (
        <PageButtonContainer
          totalPages={paginate.totalPages}
          page={paginate.page}
          setPage={setPage}
        />
      )}
    </Wrapper>
  );
};

export default TextContainer;
